export function drawImageFill(
  ctx: CanvasRenderingContext2D | null,
  img: HTMLVideoElement,
) {
  if (!ctx) {
    return;
  }

  const imageWidth = img.videoWidth;
  const imageHeight = img.videoHeight;

  const widthRatio = imageWidth / ctx.canvas.width;
  const heightRatio = imageHeight / ctx.canvas.height;
  const ratio = Math.min(heightRatio, widthRatio);

  const scaledCanvasWidth = ctx.canvas.width * ratio;
  const scaledCanvasHeight = ctx.canvas.height * ratio;

  const sx = (imageWidth - scaledCanvasWidth) / 2;
  const sy = (imageHeight - scaledCanvasHeight) / 2;

  ctx.drawImage(
    img,
    sx,
    sy,
    scaledCanvasWidth,
    scaledCanvasHeight,
    0,
    0,
    ctx.canvas.width,
    ctx.canvas.height,
  );
}
